import { bunja } from 'bunja';
import { atom } from 'jotai';

import { accountBunja } from '@flipster/r230522/original/account';

export const leverageRestrictionBunja = bunja(() => {
  const { v2AccountAtom } = bunja.use(accountBunja);

  const leverageRestrictionAtom = atom((get) => {
    const account = get(v2AccountAtom);
    const maxInitLeverageRestriction = account?.maxInitLeverageRestriction;
    return {
      isMaxInitLeverageRestricted: Boolean(maxInitLeverageRestriction),
      maxInitLeverageRestriction,
    };
  });

  return {
    leverageRestrictionAtom,
  };
});

leverageRestrictionBunja.debugLabel = 'leverageRestrictionBunja';
